<script>
import { mapGetters } from 'vuex';
import { useAlert } from 'dashboard/composables';
import router from '../../../../index';
import PageHeader from '../../SettingsSubPageHeader.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';

export default {
  components: { PageHeader, NextButton },
  data() {
    return { inboxName: '', accessToken: '' };
  },
  computed: {
    ...mapGetters({ uiFlags: 'inboxes/getUIFlags' }),
  },
  methods: {
    async createChannel() {
      if (!this.inboxName.trim() || !this.accessToken) {
        useAlert('Заполните название и access_token бота MAX');
        return;
      }
      try {
        const inbox = await this.$store.dispatch('inboxes/createChannel', {
          name: this.inboxName.trim(),
          channel: {
            type: 'max',
            provider_config: { access_token: this.accessToken },
          },
        });
        router.replace({
          name: 'settings_inboxes_add_agents',
          params: { page: 'new', inbox_id: inbox.id },
        });
      } catch (error) {
        useAlert(error?.response?.data?.message || 'Не удалось создать источник MAX');
      }
    },
  },
};
</script>

<template>
  <div class="w-full h-full col-span-6 p-6">
    <PageHeader
      header-title="Мессенджер MAX"
      header-content="Источник MAX через Bot API (отправка/приём сообщений бота)."
    />
    <form class="flex flex-col flex-wrap mx-0" @submit.prevent="createChannel">
      <div class="flex-shrink-0 flex-grow-0">
        <label>Название инбокса<input v-model="inboxName" type="text" placeholder="Например: MAX клиника" /></label>
      </div>
      <div class="flex-shrink-0 flex-grow-0">
        <label>access_token бота MAX<input v-model="accessToken" type="text" /></label>
      </div>
      <div class="w-full mt-4">
        <NextButton :is-loading="uiFlags.isCreating" type="submit" solid blue label="Создать источник" />
      </div>
    </form>
  </div>
</template>
